export default __webpack_public_path__ + "static/media/dev-united-naming.6b8fdb9a.svg";